/**
 * ViewportFrame — the persistent dossier overlay.
 * Composes Letterbox (top/bottom), HUDCrosshairs, Timecode, ChapterCounter,
 * and a thin inset border. Always visible across all 9 sections.
 */

import { Letterbox } from "./Letterbox";
import { HUDCrosshairs } from "./HUDCrosshairs";
import { Timecode } from "./Timecode";
import { ChapterCounter } from "./ChapterCounter";
import { frameCopy } from "@/lib/voice";

export function ViewportFrame() {
  return (
    <>
      {/* Thin inset border */}
      <div
        aria-hidden="true"
        style={{
          position: "fixed",
          top: "var(--frame-inset)",
          left: "var(--frame-inset)",
          right: "var(--frame-inset)",
          bottom: "var(--frame-inset)",
          border: "1px solid rgba(245, 240, 228, 0.12)",
          pointerEvents: "none",
          zIndex: 100,
        }}
      />

      <HUDCrosshairs />

      <Letterbox position="top">
        <Timecode />
        <span
          className="type-meta-sm"
          style={{ color: "var(--fog)", opacity: 0.6 }}
        >
          {frameCopy.issue}
        </span>
        <ChapterCounter />
      </Letterbox>

      <Letterbox position="bottom">
        <span
          className="type-meta-sm"
          style={{
            color: "var(--fog)",
            opacity: 0.6,
            letterSpacing: "var(--ls-meta-extra)",
          }}
        >
          {frameCopy.motto}
        </span>
        <span
          className="type-meta-sm"
          style={{ color: "var(--fog)", opacity: 0.6 }}
        >
          {frameCopy.watermark}
        </span>
      </Letterbox>
    </>
  );
}
